"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vbWFwL3Bob3RvZ3JhbS90ZXJtcy1jb25kaXRpb24tZGlhbG9nL3Rlcm1zLWNvbmRpdGlvbi1kaWFsb2cuY29tcG9uZW50LnNjc3MifQ== */"];
exports.styles = styles;
